<template>
  <el-dialog title="Update Apply Reason" :close-on-click-modal="false" :visible.sync="visible" width="600px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off">
      <el-form-item prop="remark">
        <el-input
          v-model="dataForm.remark"
          type="textarea"
          :rows="6"
          :autosize="{ minRows: 5 }"
          resize="none"
          placeholder="Update Apply Reason"
          v-regexFilter="halfWidthRegex"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">Submit</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        refundId: "",
        remark: "",
      },
      dataRule: {
        remark: [{ required: true, message: "please enter", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  methods: {
    ...mapActions("applyment", ["doRefundReplenish", "initApplyment"]),
    async init(data) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      const dataCopy = JSON.parse(JSON.stringify(data));
      this.dataForm = {
        refundId: dataCopy.id,
        remark: dataCopy.applyReason || "",
      };
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.doRefundReplenish({ ...this.dataForm })
            .then(async () => {
              // 更新申请单详情
              await this.initApplyment(this.detail.id);
              this.$message({
                message: "success",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.visible = false;
                },
              });
            })
            .catch(msg => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
